import { createSvgIcon } from './createSvgIcon'

export default createSvgIcon(
  <>
    <path d="M10 18h4v-2h-4zM3 6v2h18V6zm3 7h12v-2H6z"></path>
  </>,
  'FilterList',
)
